import { useCallback } from 'react'
import useConfig from './useConfig'

export const usePuzzleTypeImageUrls = () => {
  const config = useConfig()
  const entityImagesPath = `/entity/${config?.entity?.name ?? 'klubble_nl'}/images`

  const getBackgroundUrl = useCallback((puzzleNameLangKey: string) => {
    return `${entityImagesPath}/pzl-typ-backgrounds/${puzzleNameLangKey}.png`
  }, [entityImagesPath])

  const getIconUrl = useCallback((puzzleNameLangKey: string) => {
    return `${entityImagesPath}/pzl-typ-icn/${puzzleNameLangKey}.png`
  }, [entityImagesPath])

  return {
    getBackgroundUrl,
    getIconUrl,
  }
}
